import request from '@/utils/request'

// 查询【请填写功能名称】列表
export function listReport(query) {
    return request({
        url: '/report/list',
        method: 'get',
        params: query
    })
}

// 查询【请填写功能名称】详细
export function getReport(id) {
    return request({
        url: '/report/' + id,
        method: 'get'
    })
}

// 新增【请填写功能名称】
export function addReport(data) {
    return request({
        url: '/report',
        method: 'post',
        data: data
    })
}

// 修改【请填写功能名称】
export function updateReport(data) {
    return request({
        url: '/report',
        method: 'put',
        data: data
    })
}

// 删除【请填写功能名称】
export function delReport(id) {
    return request({
        url: '/report/' + id,
        method: 'delete'
    })
}

// 导出【请填写功能名称】
export function exportReport(query) {
    return request({
        url: '/report/export',
        method: 'get',
        params: query
    })
}